import React from 'react';

const steps = [
  {
    label: 'Discover',
    desc: 'Search or browse products.',
  },
  {
    label: 'Select',
    desc: 'Review product and purchasing information.',
  },
  {
    label: 'Shop or Source',
    desc: 'Purchase products or submit a business sourcing requirement.',
  },
  {
    label: 'Fulfil',
    desc: 'Access available delivery and fulfilment options.',
  },
];

const HowItWorks = () => {
  return (
    <section className="bg-green-50 py-16 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-10">
          How It Works
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div
              key={step.label}
              className="bg-white rounded-xl shadow-sm p-6 transition-all duration-300 hover:shadow-lg hover:scale-105 text-left h-full"
            >
              <span className="inline-flex w-10 h-10 items-center justify-center rounded-full bg-green-100 text-green-700 font-bold text-sm mb-4">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{step.label}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
